module.exports = __webpack_public_path__ + "img/mdm-deploy-2.b796a69d.webp";